import * as React from 'react';
import { styles } from './styles';
import { cx } from 'emotion';

interface Props {
  scrolling: boolean;
  children: React.ReactNode;
}

export const ModalWrapper: React.SFC<Props> = ({ children, scrolling }) => {
  const classNames = cx('modal', styles.container(scrolling));
  return <div className={classNames}>{children}</div>;
};
